module.exports = __webpack_public_path__ + "img/img01.d1540204.png";